/* eslint-disable max-len */
import React from "react";
import { connect } from "react-redux";
import { object, array, func, number, bool, string } from "prop-types";
import get from "lodash/get";
import { LoadMoreCollectionStories } from "@quintype/components";

import More from "../../atoms/More";
import NewsWithImage from "../../molecules/NewsWithImage";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";

import { getSlug, getCollectionName } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";

import "./fourColStoriesWithLoadMore.m.css";

const NO_OF_STORIES_TO_LOAD = 8;

const FourColStoriesWithLoadMore = ({ collection, sections, lang, domainSlug }) => {
  const storiesToLoad = get(collection, ["associated-metadata", "number_of_stories_inside_collection_to_show"], 4);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], true);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const stories = collection.items
    .filter((item) => item.type === "story")
    .map(({ story }) => story)
    .slice(0, storiesToLoad);

  if (!stories.length) {
    return null;
  }

  return (
    <div styleName="base">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} />
      )}

      <LoadMoreCollectionStories
        template={(e) => MoreCollectionStories(e, lang)}
        collectionSlug={collection.slug}
        data={{ stories: stories }}
        params={{ "item-type": "story" }}
        numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
      />
    </div>
  );
};

function MoreCollectionStories({ stories, onLoadMore, noMoreStories }, lang) {
  return (
    <div>
      <div styleName="wrapper">
        {stories.map((story, index) => (
          <NewsWithImage key={index} story={story} />
        ))}
      </div>
      <div>
        {!noMoreStories ? (
          <div styleName={`load-more`}>
            <More type="load-more" text={staticTexts(lang).loadMore} onClick={onLoadMore} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

FourColStoriesWithLoadMore.propTypes = {
  collection: object,
  story: object,
  sections: array,
  lang: string,
  domainSlug: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
  lang: string,
};

FourColStoriesWithLoadMore.storyLimit = 4;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(FourColStoriesWithLoadMore);
